module.exports = __webpack_public_path__ + "static/6p-2-2c678c99b22c1c4201b912070384a5c1.jpg";